import React from 'react'
import Goals from '../Goals/Goals.jsx'

export default function MyGoals({ layoutClass }) {
  return (
    <div className="ms-goals-wrap">
      <Goals />
    </div>
  )
}
